import { useState } from "react";
import { useSessao } from "@/sessao/useSessao";
import { useAdicionarRede } from "@/api/consultas";
import { textoDoErro } from "@/api/problema";
import { Campo } from "@/componentes/Campo";
import { ModalDeCadastro } from "@/componentes/ModalDeCadastro";
import { useAvisos } from "@/componentes/Avisos";
import { conferirRede } from "./rede";

/*
 * Liberar uma rede para a aplicação — change add-restricao-de-ip.
 *
 * `redeInicial` vem preenchida quando o operador parte da última recusa. O
 * formulário ABRE com o endereço, e não grava: o endereço recusado é de quem
 * bateu na API, e só vira rede liberada depois de o cliente confirmar que é a
 * saída dele (spec, "Cliente não sabe o próprio IP de saída"). Quem tenta com
 * a chave roubada também aparece ali.
 *
 * A conferência local só poupa a ida. As recusas da API — rede repetida, teto
 * de redes, a regra exata de normalização — aparecem no rodapé do modal, que
 * continua aberto com o que foi digitado.
 */
export function AdicionarRede({
  sistemaID,
  sistemaNome,
  redeInicial,
  aoFechar,
}: {
  sistemaID: string;
  sistemaNome: string;
  redeInicial: string;
  aoFechar: () => void;
}) {
  const { cliente } = useSessao();
  const avisos = useAvisos();
  const adicionar = useAdicionarRede(cliente, sistemaID);

  const [rede, setRede] = useState(redeInicial);
  const [descricao, setDescricao] = useState("");
  const [erroDaRede, setErroDaRede] = useState<string | undefined>();
  const [erroDaDescricao, setErroDaDescricao] = useState<string | undefined>();

  function enviar() {
    const conferida = conferirRede(rede);
    const descricaoLimpa = descricao.trim();

    setErroDaRede(conferida.ok ? undefined : conferida.erro);
    setErroDaDescricao(descricaoLimpa === "" ? "Informe a descrição." : undefined);
    if (!conferida.ok || descricaoLimpa === "") return;

    adicionar.mutate(
      { rede: rede.trim(), descricao: descricaoLimpa },
      {
        onSuccess: (gravada) => {
          // A forma GRAVADA, e não a digitada: `203.0.113.10` vira
          // `203.0.113.10/32`, e é essa que a lista vai mostrar.
          avisos.feito("Rede adicionada", gravada.rede);
          aoFechar();
        },
      },
    );
  }

  return (
    <ModalDeCadastro
      aberto
      aoFechar={aoFechar}
      titulo="Adicionar rede"
      descricao={sistemaNome}
      aoEnviar={enviar}
      enviando={adicionar.isPending}
      erro={adicionar.error ? textoDoErro(adicionar.error) : undefined}
      rotuloDeEnvio="Adicionar rede"
    >
      <Campo
        rotulo="Rede"
        value={rede}
        onChange={(evento) => setRede(evento.target.value)}
        placeholder="203.0.113.10 ou 203.0.113.0/24"
        autoComplete="off"
        spellCheck={false}
        autoFocus
        erro={erroDaRede}
        className="dados"
      />

      <Campo
        rotulo="Descrição"
        value={descricao}
        onChange={(evento) => setDescricao(evento.target.value)}
        placeholder="servidor de produção do parceiro"
        maxLength={120}
        erro={erroDaDescricao}
      />
    </ModalDeCadastro>
  );
}
